import { IDirective } from 'angular';
import { GmcTabController } from '../components';

export function gmcTabHeader(): IDirective {
  return {
    restrict: 'E',
    require: '^gmcTab',
    link: function postLink( scope, element, attrs, gmcTabCtrl: GmcTabController ) {
      console.log(gmcTabCtrl);
      element.css('display', 'block');
    }
  };
}



// WEBPACK FOOTER //
// ./app/shared/components/gmc-tabs/directives/gmc-tab-header.ts